<template>
  <div
    :class="[
      'retailer-search-filter-fi',
      theme ? `retailer-search-filter-fi--${theme}` : null,
      navigationActive ? 'retailer-search-filter-fi--navigation-active' : null,
    ]"
  >
    <retailer-search-location-fi
      class="retailer-search-filter-fi__search"
      :google="google"
      :autocomplete-options="autocompleteOptions"
      :loc="location"
      :location-error="locationError"
      @location-changed="locationChanged"
      @user-location-error="(val) => $emit('user-location-error', val)"
    />

    <div class="retailer-search-filter-fi__range">
      <select-input-fi
        class="retailer-search-filter-fi__range__select"
        :label="$dict.get('dealer-Locator.Circle-Entry')"
        :value="selectRange"
        :options="ranges"
        :large="isMD"
        light
        @input="rangeChanged"
        @clear-selection="clearRange"
      />
    </div>

    <div class="retailer-search-filter-fi__wrapper">
      <div class="retailer-search-filter-fi__retailer-name">
        <text-input-fi
          v-model.trim="retailerNameModel"
          class="retailer-search-filter-fi__retailer-name__input"
          :label="$dict.get('dealer-Locator.Dealer-Name')"
          icon="search"
          :large="isMD"
          light
          clear
          clear-icon="close"
          @icon-clicked="(val) => retailerNameChanged(val, true)"
          @keyup-enter="(val) => retailerNameChanged(val, true)"
          @clear="retailerNameChanged"
        />
      </div>

      <div
        v-if="retailerType && retailerType.elements.length > 1"
        class="retailer-search-filter-fi__retailer-type__mobile"
      >
        <retailer-search-type-fi
          :facet="retailerType"
          :retailers-count="retailersCount"
          @retailer-type-changed="typeChanged"
        />
      </div>
    </div>

    <div
      v-if="retailerType && retailerType.elements.length > 1"
      class="retailer-search-filter-fi__retailer-type"
    >
      <retailer-search-type-fi
        :facet="retailerType"
        :retailers-count="retailersCount"
        @retailer-type-changed="typeChanged"
      />
    </div>
  </div>
</template>

<script>
import { SelectInputFi, TextInputFi } from 'atoms';
import breakpointMixin from 'mixins/breakpointMixin';

import RetailerSearchLocationFi from './retailer-search-location-fi/RetailerSearchLocationFi';
import RetailerSearchTypeFi from './retailer-search-type-fi/RetailerSearchTypeFi';

export default {
  name: 'RetailerSearchFilterFi',
  components: {
    RetailerSearchLocationFi,
    RetailerSearchTypeFi,
    SelectInputFi,
    TextInputFi,
  },
  mixins: [breakpointMixin],
  props: {
    google: {
      type: Object,
      default: null,
    },
    location: {
      type: Object,
      default: null,
    },
    locationError: {
      type: Boolean,
      default: null,
    },
    retailerName: {
      type: String,
      default: '',
    },
    autocompleteOptions: {
      type: Object,
      default: () => ({}),
    },
    ranges: {
      type: Array,
      required: true,
    },
    defaultRange: {
      type: String,
      required: true,
    },
    theme: {
      type: String,
      default: null,
    },
    retailerSearchPage: {
      type: Boolean,
      default: false,
    },
    retailerTypes: {
      type: Array,
      default: () => [],
    },
    retailersCount: {
      type: String,
      default: null,
    },
    navigationActive: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'location-changed',
    'range-changed',
    'retailer-name-changed',
    'type-changed',
    'user-location-error',
  ],
  data() {
    return {
      internRetailerName: '',
      selectRange: null,
    };
  },
  computed: {
    retailerNameModel: {
      get() {
        return this.retailerName || this.internRetailerName;
      },
      set(value) {
        this.internRetailerName = value;
        this.retailerNameChanged(value);
      },
    },
    isModal() {
      return this.theme === 'modal';
    },
    hasUserLocationError() {
      return this.userLocationError;
    },
    retailerType() {
      return this.retailerTypes?.[0];
    },
  },
  created() {
    this.selectRange = this.defaultRange;
  },
  methods: {
    locationChanged(location) {
      if (location) {
        this.prepareDataLayer(location);
      }
      this.$emit('location-changed', location);
    },
    retailerNameChanged(value, forceEmit) {
      if (!value || value.length > 2 || forceEmit) {
        this.$emit('retailer-name-changed', value);
      }
    },
    rangeChanged(value) {
      this.selectRange = value;
      this.$emit('range-changed', value);
    },
    clearRange() {
      this.selectRange = this.defaultRange;
      this.$emit('range-changed', this.defaultRange);
    },
    typeChanged(value) {
      this.$emit('type-changed', value);
    },
    prepareDataLayer(location) {
      if (!location?.description) {
        return;
      }

      window.dataLayer = window.dataLayer || [];

      const pageDetails = window.dataLayer.filter((d) => d.pageId)[0];

      if (this.retailerSearchPage) {
        window.dataLayer.push({
          event: 'DealerSearchLocation',
          locationName: location.description,
        });
      } else if (pageDetails) {
        window.dataLayer.push({
          event: 'RCBuyLocalLocation',
          pageId: pageDetails.pageId,
          pageTitle: pageDetails.pageTitle,
          pageUrl: pageDetails.pageUrl,
          pageTemplate: pageDetails.pageTemplate,
          cartItems: pageDetails.cartItems,
          locationName: location.description,
        });
      } else {
        window.dataLayer.push({
          event: 'RCBuyLocalLocation',
          locationName: location.description,
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import './retailer-search-filter-fi';
</style>

<style lang="scss">
@import './retailer-search-filter-fi-unscoped';
</style>
